import React from "react";
import "./Home.css";

export const Workshops = () => {
  return (
    <div className="page-layout">
      <div className="text-layout">
        <h2>SmartComp 2025 Workshops</h2>
        <br />
        <h4>
          1st International Workshop on Smart AI Models and Data Sharing and
          Monetisation (SmartAIDA)
        </h4>
        <br></br>
        <p style={{ marginBottom: 0 }}>General Co-Chairs:</p>
        <ul style={{ marginTop: 2, paddingTop: 0 }}>
          <li>Dr Andrea Visentin, University Collge Cork, Ireland</li>
          <li>Professor Barry O’Sullivan, University Collge Cork, Ireland</li>
          <li>David Remon, Eclipse Foundation</li>
        </ul>
        <br />
        <p style={{ marginBottom: 0 }}>
          Paper submission deadline (EXTENDED):{" "}
          <span style={{ fontWeight: "bold", textDecoration: "line-through" }}>
            30th March 2025
          </span>{" "}
          <span style={{ fontWeight: "bold", color: "red" }}>
            21st April 2025
          </span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Paper notification date:{" "}
          <span style={{ fontWeight: "bold" }}>2nd May 2025</span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Camera-ready deadline for workshop papers:{" "}
          <span style={{ fontWeight: "bold" }}>12th May 2025</span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Workshop date:{" "}
          <span style={{ fontWeight: "bold" }}>16th June 2025</span>
        </p>
        <br />
        <p>
          Call for Papers: <a href="https://www.cs.ucc.ie/smartaida/">HERE</a>
        </p>
        <hr />
        <br />
        <h4>
          Whole-Lifecycle Security for Smart Systems: Methods and Tools
          (LIFESEC)
        </h4>
        <br></br>
        <p style={{ marginBottom: 0 }}>General Co-Chairs:</p>
        <ul style={{ marginTop: 2, paddingTop: 0 }}>
          <li>Robert Seidl, Nokia</li>
          <li>Antonio Skarmeta, University of Murcia</li>
          <li>Bernd-Ludwig Wenning, Munster Technological University</li>
        </ul>
        <br />
        <p style={{ marginBottom: 0 }}>
          Paper submission deadline (EXTENDED):{" "}
          <span style={{ fontWeight: "bold", textDecoration: "line-through" }}>
            30th March 2025
          </span>{" "}
          <span style={{ fontWeight: "bold", color: "red" }}>
            14th April 2025
          </span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Paper notification date:{" "}
          <span style={{ fontWeight: "bold" }}>2nd May 2025</span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Camera-ready deadline for workshop papers:{" "}
          <span style={{ fontWeight: "bold" }}>12th May 2025</span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Workshop date:{" "}
          <span style={{ fontWeight: "bold" }}>16th June 2025</span>
        </p>
        <br />
        <p>
          Call for Papers:{" "}
          <a href=" https://telemetry-project.eu/workshop-on-whole-lifecycle-security-for-smart-systems-methods-and-tools-lifesec/">
            HERE
          </a>
        </p>
        <hr />
        <br />
        <h4>
          1st International Workshop on Smart Solutions for Security and Privacy
          in the Edge Cloud Continuum (S3PEC)
        </h4>
        <br></br>
        <p style={{ marginBottom: 0 }}>General Co-Chairs:</p>
        <ul style={{ marginTop: 2, paddingTop: 0 }}>
          <li>Dr Sourabh Bharti, Munster Tchnological University</li>
          <li>Dr Alan McGibney, Munster Tchnological University</li>
          <li>Dr Aidan O’Mahony, DELL Technologies</li>
        </ul>
        <br />
        <p style={{ marginBottom: 0 }}>
          Paper submission deadline (EXTENDED):{" "}
          <span style={{ fontWeight: "bold", textDecoration: "line-through" }}>
            30th March 2025
          </span>{" "}
          <span style={{ fontWeight: "bold", color: "red" }}>
            21st April 2025
          </span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Paper notification date:{" "}
          <span style={{ fontWeight: "bold" }}>2nd May 2025</span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Camera-ready deadline for workshop papers:{" "}
          <span style={{ fontWeight: "bold" }}>12th May 2025</span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Workshop date:{" "}
          <span style={{ fontWeight: "bold" }}>16th June 2025</span>
        </p>
        <br />
        <p>
          Call for Papers: <a href="https://www.nimbus.cit.ie/s3pec/">HERE</a>
        </p>
        <hr />
        <br />
        <h4>
          4th International Workshop on Smart Agriculture for the environmental
          emergency (SmartAgr)
        </h4>
        <br></br>
        <p style={{ marginBottom: 0 }}>General Co-Chairs:</p>
        <ul style={{ marginTop: 2, paddingTop: 0 }}>
          <li>Anna Lina Ruscelli, Scuola Superiore Sant’Anna</li>
          <li>Gabriele Cecchetti, Scuola Superiore Sant’Anna</li>
        </ul>
        <br />
        <p style={{ marginBottom: 0 }}>
          Paper submission deadline (EXTENDED):{" "}
          <span style={{ fontWeight: "bold", textDecoration: "line-through" }}>
            30th March 2025
          </span>{" "}
          <span style={{ fontWeight: "bold", color: "red" }}>
            21st April 2025
          </span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Paper notification date:{" "}
          <span style={{ fontWeight: "bold" }}>2nd May 2025</span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Camera-ready deadline for workshop papers:{" "}
          <span style={{ fontWeight: "bold" }}>12th May 2025</span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Workshop date:{" "}
          <span style={{ fontWeight: "bold" }}>16th June 2025</span>
        </p>
        <br />
        <p>
          Call for Papers: <a href="https://smartagr.santannapisa.it/">HERE</a>
        </p>
        <hr />
        <br />
        <h4>
          2nd International Workshop on Digital and Mobile Smart Health Systems
          (DM-SmartHealth 2025)
        </h4>
        <br></br>
        <p style={{ marginBottom: 0 }}>General Co-Chairs:</p>
        <ul style={{ marginTop: 2, paddingTop: 0 }}>
          <li>
            Dr Mattia Giovanni Campana, National Research Council of Italy,
            Italy
          </li>
          <li>Professor Nikil Dutt, University of California, Irvine, USA</li>
        </ul>
        <br />
        <p style={{ marginBottom: 0 }}>
          Paper submission deadline (EXTENDED):{" "}
          <span style={{ fontWeight: "bold", textDecoration: "line-through" }}>
            30th March 2025
          </span>{" "}
          <span style={{ fontWeight: "bold", color: "red" }}>
            21st April 2025
          </span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Paper notification date:{" "}
          <span style={{ fontWeight: "bold" }}>2nd May 2025</span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Camera-ready deadline for workshop papers:{" "}
          <span style={{ fontWeight: "bold" }}>12th May 2025</span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Workshop date:{" "}
          <span style={{ fontWeight: "bold" }}>16th June 2025</span>
        </p>
        <br />
        <p>
          Call for Papers:{" "}
          <a href="https://dm-smarthealth2025.iit.cnr.it">HERE</a>
        </p>
        <hr />
        <br />
        <h4>
          10th IEEE International Workshop on Smart Service Systems (SmartSys
          2025)
        </h4>
        <br></br>
        <p style={{ marginBottom: 0 }}>General Co-Chairs:</p>
        <ul style={{ marginTop: 2, paddingTop: 0 }}>
          <li>Nirmalya Roy, University of Maryland</li>
          <li>Carlo Vallati, University of Pisa</li>
          <li>Gurdip Singh, George Mason University</li>
        </ul>
        <br />
        <p style={{ marginBottom: 0 }}>
          Paper submission deadline (EXTENDED):{" "}
          <span style={{ fontWeight: "bold", textDecoration: "line-through" }}>
            30th March 2025
          </span>{" "}
          <span style={{ fontWeight: "bold", color: "red" }}>
            21st April 2025
          </span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Paper notification date:{" "}
          <span style={{ fontWeight: "bold" }}>2nd May 2025</span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Camera-ready deadline for workshop papers:{" "}
          <span style={{ fontWeight: "bold" }}>12th May 2025</span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Workshop date:{" "}
          <span style={{ fontWeight: "bold" }}>16th June 2025</span>
        </p>
        <br />
        <p>
          Call for Papers: <a href="http://smartsys2025.dii.unipi.it">HERE</a>
        </p>
        <hr />
        <br />
        <h4>11th Workshop on Sensors and Smart Cities (SSC)</h4>
        <br></br>
        <p style={{ marginBottom: 0 }}>General Co-Chairs:</p>
        <ul style={{ marginTop: 2, paddingTop: 0 }}>
          <li>Dario Bruneo, University of Messina</li>
          <li>Antonio Puliafito, University of Messina</li>
        </ul>
        <br />
        <p style={{ marginBottom: 0 }}>
          Paper submission deadline (EXTENDED):{" "}
          <span style={{ fontWeight: "bold", textDecoration: "line-through" }}>
            30th March 2025
          </span>{" "}
          <span style={{ fontWeight: "bold", color: "red" }}>
            21st April 2025
          </span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Paper notification date:{" "}
          <span style={{ fontWeight: "bold" }}>2nd May 2025</span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Camera-ready deadline for workshop papers:{" "}
          <span style={{ fontWeight: "bold" }}>12th May 2025</span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Workshop date:{" "}
          <span style={{ fontWeight: "bold" }}>16th June 2025</span>
        </p>
        <br />
        <p>
          Call for Papers: <a href="https://portale2.unime.it/ssc2025/">HERE</a>
        </p>
      </div>
    </div>
  );
};
